'use strict';
import angular from 'angular'

function ObrasGovMapController($rootScope, $scope, $location, $window, objectMakerFactory, dataHolderFactory, dataRequestService, localStorageService, usSpinnerService, appSettings, $translate, extDbTranslateConfig, constantSettings) {
  const self = this;

  $scope.renderApp = false;

  this.getUniqueStatus = function(status) {
    const unique = {};
    const distinct = [];
    status.forEach(function(st) {
      if (!unique[st.name]) {
        distinct.push(st);
        unique[st.name] = true;
      }
    });
    return distinct;
  };

  this.initFilterContract = function(cb){

    var searchObject = $location.search();

    if(searchObject.contrato) {

      var decodedContratoId = $window.atob(searchObject.contrato);

      dataRequestService.getContractDetails(decodedContratoId).then(function (contrato) {

        var initialDate = new Date(contrato.periodValidity.initialDate);
        var finalDate = new Date(contrato.periodValidity.finalDate);

        var filterOptions = dataHolderFactory.getSavedFilterOptions();
        filterOptions.period.initialDate = initialDate;
        filterOptions.period.finalDate = finalDate;

        cb(filterOptions)
      });
    }else {
      cb(dataHolderFactory.getSavedFilterOptions());
    }
  };

	this.getContracts = function (cb) {
		usSpinnerService.spin('spinner-1');
		self.initFilterContract(function(filters) {
      return dataRequestService.getContractsData(objectMakerFactory.viewObjectExtractionForFilter(filters)).then(function (data) {
        usSpinnerService.stop('spinner-1');
        data.forEach(function(contract) {
          contract.showAddress = false;

          contract.period.initialDate = contract.period.initialDate ? new Date(parseInt(contract.period.initialDate)) : null
          contract.period.finalDate = contract.period.initialDate ? new Date(parseInt(contract.period.finalDate)) : null
        });
        dataHolderFactory.updateContracts(data);
        $rootScope.$emit('applyFilters');
        if (cb) {
          cb();
        }
      }, function(error) {
        usSpinnerService.stop('spinner-1');
        console.log(error);
      });
    });
	};

  this.configureFilters = function() {
    const hasDefaults = $scope.appSettings && $scope.appSettings.getConfig().default;
    const defaultStatus = hasDefaults && $scope.appSettings.getConfig().default.status
      ? $scope.appSettings.getConfig().default.status
      : [];

    usSpinnerService.spin('spinner-1');
    dataRequestService.getFiltersData().then(function(data) {
      usSpinnerService.stop('spinner-1');
      angular.forEach(data.documents, (model) => model.selected = true);
      angular.forEach(data.places, (model) => model.selected = false);
      angular.forEach(data.status, (model) => { model.selected = model.flDefaultfiltroMapa === 'S';});
      angular.forEach(data.communityAssets, (model) => model.selected = false);
      angular.forEach(data.organs, (model) => model.selected = true);
      angular.forEach(data.contracteds, (model) => model.selected = false);
      angular.forEach(data.enterprises, (model) => model.selected = true);
      angular.forEach(data.programs, (model) => model.selected = true);
      angular.forEach(data.sectors, (model) => model.selected = true);
      angular.forEach(data.classifications, (model) => model.selected = true);
      angular.forEach(data.tematicas, (model) => model.tematicas = false);

      angular.forEach(data.categories, (model) => {
        model.selected = true;
        model.expanded = false;
        angular.forEach(model.subcategories, (subModel) => subModel.selected = true);
      });

      data.uniqueStatus = self.getUniqueStatus(data.status);
      dataHolderFactory.updateFilterOptions(data);
      dataHolderFactory.updateFavoriteFilterSelected(data);
      localStorageService.set('originalFilters', data);
      self.getContracts();

      $scope.renderApp = true;
    }, function(error) {
      console.log(error);
    });
  };

  $rootScope.$on('newFavoriteFilterSelected', function() {
    self.getContracts(() => {
      $rootScope.$emit('openViewWithContext', 'CONTRACTS');
    });
  });

  this.convertImgToDataURLviaCanvas = function(url, callback) {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function() {
      let canvas = document.createElement('CANVAS');
      const ctx = canvas.getContext('2d');
      canvas.height = this.height;
      canvas.width = this.width;
      ctx.drawImage(this, 0, 0);
      callback(canvas.toDataURL());
      canvas = null;
    };
    img.src = url;
  };

  const ignorePorts = [
    { protocol: 'http', port: 80 },
    { protocol: 'https', port: 443 }
  ];

  const addServerPort = function(protocolPort) {
    let isValid = true;
    angular.forEach(ignorePorts, function(ignorePort) {
      if (angular.equals(ignorePort, protocolPort)) {
        isValid = false;
      }
    });
    return isValid ? (':' + protocolPort.port) : '';
  };

  this.configureApp = function() {
    const dynamicAddress = $location.$$protocol + "://" + $location.$$host + addServerPort({
      protocol: $location.$$protocol,
      port:     $location.$$port
    }) + '/';
    const dns = $location.$$host;

    appSettings.setBaseUrl(dynamicAddress);
    usSpinnerService.spin('spinner-1');

    dataRequestService.getAppConfiguration(dns).then(function(data) {
      usSpinnerService.stop('spinner-1');
      appSettings.setSource(data.tenantId);

      if (data.zoom) {
        appSettings.setDefaultZoom(data.zoom);
      }

      appSettings.setAnalyticsKey(data.analyticsKey);
      appSettings.setGoogleApiKey(data.googleApiKey);
      appSettings.setTenantClient(data.tenantClient);

      if (data.logoUrl) {
        $rootScope.appControl.logoUrl = data.logoUrl;
        self.convertImgToDataURLviaCanvas(data.logoUrl, function(img) {
          localStorageService.set('logo', img);
        });
      }
      if (data.urlKml) {
        $rootScope.appControl.urlKml = data.urlKml;
      }
      data.about && appSettings.setAbout(data.about);
      data.defaultCoordinate && appSettings.setDefaultCoordinate(data.defaultCoordinate);

      self.loadClientConfig().then(() => {
        prepareTranslate(data.tenantId);
        loadFavoriteFilters();
      });

      if (appSettings.getAnalyticsKey()) {
        (function (i, s, o, g, r, a, m) {
          i.dataLayer = i.dataLayer || [];
          i[r] = i[r] || function () {i.dataLayer.push(arguments);};
          a = s.createElement(o), m = s.getElementsByTagName(o)[0];
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
          self.initGoogleAnalytics(constantSettings.actionViewMap);
        })($window, document, 'script', 'https://www.googletagmanager.com/gtag/js?id='+appSettings.getAnalyticsKey(), 'gtag');      
      }      
    }, function(error) {
      usSpinnerService.stop('spinner-1');
      console.log(error);
    });
  };

  self.loadClientConfig = () => {
    function updateConfig(...configs) {
      let config = configs.reduce((previousValue, currentValue) => {
          previousValue.filter = { ...previousValue.filter, ...currentValue.filter };
          previousValue.show = { ...previousValue.show, ...currentValue.show };
          previousValue.default = { ...previousValue.default, ...currentValue.default };
          previousValue.contratoDetalhes = { ...previousValue.contratoDetalhes, ...currentValue.contratoDetalhes };
          return previousValue;
        }
      );

      appSettings.setConfig(config);
      $scope.appSettings = appSettings;
      self.configureFilters();
    }

    return dataRequestService.getClientConfigJsonLocal().then(function success(configJsonPadrao) {
      return dataRequestService.getClientConfigJsonLocal(appSettings.getSource()).then(function success(configJsonCliente) {
        return dataRequestService.getClientConfigJsonBancoDados().then(function success(configJsonBd) {
          updateConfig(configJsonPadrao, configJsonCliente, configJsonBd);
        }, function error(error) {
          console.log(error);
          updateConfig(configJsonPadrao, configJsonCliente)
        });
      }, function error(error) {
        console.log(error);
        updateConfig(configJsonPadrao)
      });
    });
  };

  self.initGoogleAnalytics = function(actionMapa) {

    const nmSistema = 'Mapa';
    const client = appSettings.getTenantClient(); 

    if (!$window.gtag) {
      setTimeout(getGoogleAnalytics(actionMapa), 200);
    } else {
      getGoogleAnalytics(actionMapa);
    }

    function getGoogleAnalytics(actionMapa) {

	    $window.gtag('js', new Date());
	    $window.gtag('config', appSettings.getAnalyticsKey());
      
      $window.gtag('set', 'user_properties', {
        dimension2: client,
        dimension3: nmSistema,
        dimension4: actionMapa
     });

      $window.gtag('event', 'page_view', {
        page_path: actionMapa,
        page_location: $window.location.href,
        page_title: actionMapa
      });
    }
  };

  $rootScope.$on('setGoogleAnalyticsData', function(event, pageAction) {
    if (appSettings.getAnalyticsKey()){
      self.initGoogleAnalytics(pageAction);   
    }
  });


  $scope.initAppController = function() {
    $rootScope.appControl = objectMakerFactory.viewObjectControlForApp();
    self.configureApp();
  };

  function prepareTranslate(tenantId) {
    if (appSettings.config.show.customLabels) {
      dataRequestService.getLabels(tenantId).then(function(response) {
        extDbTranslateConfig.setExtendedLabels(response.toJSON());
        $translate.use('pt-BR');
        $translate.use('pt-BR-' + appSettings.getSource());
      });
    } else {
      $translate.use('pt-BR');
      $translate.use('pt-BR-' + appSettings.getSource());
    }
  }

  function loadFavoriteFilters() {
    if (appSettings.config.show.favoriteFilters) {
      dataRequestService.getFavoriteFilters().then(function(response) {
        const favoriteFilters = response.data.map(filter => {
          filter.fields = JSON.parse(filter.json);
          return filter;
        });
        dataHolderFactory.updateFavoriteFilters(favoriteFilters);
      });
    }
  }

}

ObrasGovMapController.$inject = ['$rootScope', '$scope', '$location', '$window', 'objectMakerFactory', 'dataHolderFactory', 'dataRequestService', 'localStorageService',
  'usSpinnerService', 'appSettings', '$translate', 'extDbTranslateConfig', 'constantSettings'];

export default ObrasGovMapController;



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/obrasGovMapController.js